import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BroadcastService } from '@services/broadcast-service/index';
import { WindowRefService } from '@services/window-ref-service/index';
import { UserAllocatedDoctorService } from '@services/user-allocated-doctor-service/user-allocated-doctor.service';
import { DoctorProfile } from '@cureskin/api-client-rn';
import { AppConfig } from '../../app.config';

@Component({
  selector: 'doctor-view',
  templateUrl: './doctor-view.html',
  standalone: false,
})
export class DoctorViewComponent {
  doctor: DoctorProfile;

  constructor(private broadcast: BroadcastService,
    private window: WindowRefService,
    public appConfig: AppConfig,
    private route: ActivatedRoute,
    private readonly userAllocatedDoctorService: UserAllocatedDoctorService) {}

  async ngOnInit(): Promise<void> {
    this.doctor = await this.userAllocatedDoctorService.getDoctorById(this.route.snapshot.params.id);
  }

  back(): void {
    this.broadcast.broadcast('NAVIGATION_BACK');
  }
}
